import { Badge, Modal, Table, Text } from "@mantine/core";
import { useStorage } from "./ZustandState";
import { getHistory } from "./HistoryTable";
import { formatEvaluation } from "./utils";

interface Props {
    opened: boolean;
    close: () => void;
}

const judgementColor: Record<string, string> = {
    inaccuracy: "blue",
    mistake: "orange",
    blunder: "red",
    good: "green",
};

const StockfishInfoModal: React.FC<Props> = ({ opened, close }) => {
    const moveHistory = useStorage((state) => state.moveHistory);
    const evaluations = useStorage((state) => state.evaluations);

    const evalByFen = new Map(Object.values(evaluations).map((e) => [e.fen, e]));
    const history = getHistory(moveHistory, evaluations);

    const rows = history
        .filter((entry) => entry.evaluation !== undefined && entry.evaluation !== "-")
        .map((entry, i) => {
            const moveNumber = Math.floor(i / 2) + 1;
            const isWhite = i % 2 === 0;
            const moveLabel = isWhite ? `${moveNumber}.` : `${moveNumber}...`;

            const rawEval = evalByFen.get(moveHistory[i]?.after);

            return (
                <Table.Tr key={i}>
                    <Table.Td c="dimmed" fz="sm">
                        {moveLabel}
                    </Table.Td>
                    <Table.Td fz="sm" fw={500}>
                        {entry.move}
                    </Table.Td>
                    <Table.Td fz="sm">{entry.evaluation !== "-" ? entry.evaluation : "-"}</Table.Td>
                    <Table.Td fz="sm" c="dimmed">
                        {rawEval?.depth ?? "-"}
                    </Table.Td>
                    <Table.Td fz="sm" c="dimmed">
                        {rawEval?.time != null ? `${rawEval.time} ms` : "-"}
                    </Table.Td>
                    <Table.Td fz="sm">
                        <Badge color={judgementColor[entry.judgement || "good"]} variant="light" size="sm">
                            {entry.judgement || "Good move"}
                        </Badge>
                    </Table.Td>
                </Table.Tr>
            );
        });

    return (
        <Modal
            opened={opened}
            onClose={close}
            title={
                <Text fz="h3" fw="bold">
                    Stockfish Evaluations
                </Text>
            }
            centered
            size="xl"
        >
            {rows.length === 0 ? (
                <Text c="dimmed">No evaluation data available.</Text>
            ) : (
                <Table striped highlightOnHover withTableBorder withColumnBorders>
                    <Table.Thead>
                        <Table.Tr>
                            <Table.Th>#</Table.Th>
                            <Table.Th>Move</Table.Th>
                            <Table.Th>Eval</Table.Th>
                            <Table.Th>Depth</Table.Th>
                            <Table.Th>Time</Table.Th>
                            <Table.Th>Judgement</Table.Th>
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>{rows}</Table.Tbody>
                </Table>
            )}
        </Modal>
    );
};

export default StockfishInfoModal;
